<div #columnsDropdown="ngbDropdown" container="body" ngbDropdown placement="bottom-right">
	<button class="btn btn-info" id="columnMenu" jhiTranslate="germplasm-list.list-data.show-columns-button" ngbDropdownToggle></button>
	<div aria-labelledby="columnMenu" class="column-menu p-2" ngbDropdownMenu>
		<form #f='ngForm'>
			<div class="columns-container">
				<div class="inner-addon right-addon mb-2">
					<i class="fa fa-search"></i>
					<input (keyup)="onSearchColumn($event)" class="form-control" placeholder="{{ 'search' | translate }}" type="text"/>
				</div>
				<div *ngIf="this.checkAreColumnsVisible(this.staticColumns)" class="mt-3">
                    @if (showEnvironmentsLabel) {
                        <label class="form-check-label fw-bold">{{'queries.columns.dropdown.label.environment' | translate}}</label>
                        <hr class="mt-1 mb-1"/>
                    }
					<div *ngFor="let column of this.staticColumns" class="form-check">
						<div *ngIf="column.visible">
							<input [(ngModel)]="column.selected" class="form-check-input" id="check-name-{{column.id}}"
								   name="'check-name-{{column.id}}'" type="checkbox">
							<label class="form-check-label" for="check-name-{{column.id}}">
								{{ column.name | translate }}
							</label>
						</div>
					</div>
				</div>
                <div *ngIf="this.checkAreColumnsVisible(this.traitColumns)" class="mt-3">
                    <label class="form-check-label fw-bold">{{'queries.columns.dropdown.label.traits' | translate}}</label>
                    <hr class="mt-1 mb-1"/>
                    <div *ngFor="let column of this.traitColumns" class="form-check">
                        <div *ngIf="column.visible">
                            <input [(ngModel)]="column.selected" class="form-check-input" id="check-name-{{column.id}}"
                                   name="'check-name-{{column.id}}'" type="checkbox">
                            <label class="form-check-label" for="check-name-{{column.id}}">
                                {{ column.name }}
                            </label>
                        </div>
                    </div>
                </div>
				<div *ngIf="this.checkAreColumnsVisible(this.environmentVariableColumns)" class="mt-3">
					<label class="form-check-label fw-bold">{{ 'queries.columns.dropdown.label.environment-details' | translate}}</label>
					<hr class="mt-1 mb-1"/>
					<div *ngFor="let column of this.environmentVariableColumns" class="form-check">
						<div *ngIf="column.visible">
							<input [(ngModel)]="column.selected" class="form-check-input" id="check-name-{{column.id}}"
								   name="'check-name-{{column.id}}'" type="checkbox">
							<label class="form-check-label" for="check-name-{{column.id}}">
								{{ column.name }}
							</label>
						</div>
					</div>
				</div>
			</div>
			<hr class="mt-3 mb-0"/>
			<div class="text-center"><br>
				<button (click)="apply()" class="btn btn-primary btn-sm" data-test="displayColumnApplyButton"
						type="submit">{{'apply' | translate}}
				</button>
			</div>
		</form>
	</div>
</div>
